<template>
  <transition-group name="f-slide-fade">
    <core-contextual-error-box v-if="loadError" key="error" :action="load" />

    <div
      v-else-if="!hasFiles"
      key="empty"
      class="flex justify-center p-6 text-center"
    >
      <div class="max-w-xs border border-dashed border-gray-300 dark:border-charcoal-500 rounded-lg bg-white/80 dark:bg-charcoal-800 p-6 shadow-sm dark:shadow-none dark:ring-1 dark:ring-charcoal-600">
        <u-icon name="i-ri-image-line" class="text-3xl text-gray-400 dark:text-gray-200 mx-auto mb-3" />
        <div class="text-lg font-semibold text-charcoal dark:text-gray-100">No photos yet</div>
        <div class="text-sm text-gray-600 dark:text-gray-200 mt-2">Return to the Album and add photos to use in this design.</div>
      </div>
    </div>

    <file-list-grid
      class="pl-3 pt-1"
      key="list-grid"
      ref="listComp"
      :scrollbar-width="12"
      :scrollbar-width-sm="12"
      :files-store-id="FILES_STORE_ID"
      v-else
      :files="files"
      :disable-approach-bottom="!hasMoreFiles"
      disable-selection
      disable-context-menu
      disable-back-to-top
      :grid-size-id="GRID_SIZE_ID"
      @approach-bottom="getMore"
      @list-item-click="file => addImage(file)"
    >
      <template #list-item-optional-items="{file}">
        <div
          class="absolute-cover draggable-file"
          draggable="true"
          @pointerdown="event => onPointerDown(event, file)"
          @dragstart="event => onDragStart(event, file)"
          @dragend="onDragEnd"
        />
      </template>
    </file-list-grid>

  </transition-group>
</template>

<script setup>
  import {storeToRefs} from 'pinia';
  import {makeFilesStore} from '~/stores/files.js';

  const props = defineProps({
    album: Object
  });

  const FILES_STORE_ID = 'custom-album-cover-editor-files-store';

  const filesStore = makeFilesStore(FILES_STORE_ID)();
  const {files, hasMore, isPageQueued} = storeToRefs(filesStore);
  const hasMoreFiles = computed(() => !isPageQueued.value && hasMore.value);

  const {addImage, onPointerDown, onDragStart, onDragEnd} = useSurfaceEditorPhotoActions();

  const GRID_SIZE_ID = 'surface-editor-photos-tab';

  const grid = useFileListGrid({id: GRID_SIZE_ID});
  grid.setSize(100);

  const hasFiles = computed(() => (files.value?.length || 0) > 0);

  const loadError = ref(null);
  const getMoreError = ref(null);

  async function load() {
    try {
      await filesStore.getFiles({
        context: props.album,
        contextType: FILE_CONTEXTS.album,
        order: {param_name: props.album.file_sort},
        fileTypes: [FILE_TYPES.photo],
        updateContextFileOrder: false
      });
    } catch (e) {
      loadError.value = e;
    }
  }

  async function getMore() {
    if (!hasMoreFiles.value) {
      return;
    }

    try {
      await filesStore.getFiles({nextPage: true});
    } catch (e) {
      getMoreError.value = e; //todo: what do we do?
    }
  }

  onMounted(() => {
    load();
  });

  onUnmounted(() => {
    filesStore.clearFiles();
  });

  const listComp = ref();

  onActivated(async () => {
    listComp.value?.refreshScrollPosition();
  });

</script>
